import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import Checkbox from "@shared/v2/Checkbox";
import Dropdown from "@shared/v2/Dropdown";
import TextInput from "@shared/v2/TextInput";
import FormWrapper from "./form_controls/FormWrapper";

const EditSuperUserForm = ({ onCancel, onSubmit, roleOptions, formErrors, superUser }) => {
  const [email, setEmail] = useState(superUser.email);
  const [password, setPassword] = useState("");
  const [changePassword, setChangePassword] = useState(false);
  const [role, setRole] = useState(superUser.role);
  const roleDropdownOptions = useMemo(() => roleOptions.map((r) => ({ value: r, label: r })), [roleOptions]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const params = { email, role };

    if (changePassword) {
      params.password = password;
    }

    onSubmit(superUser.id, params);
  };

  const validate = (name) => {
    if (formErrors && formErrors[name]) {
      return "error";
    }
    return null;
  };

  return (
    <FormWrapper formErrors={formErrors} onCancel={onCancel} onSubmit={handleOnSubmit}>
      <TextInput
        label="Email"
        name="email"
        value={email}
        error={validate("email") === "error"}
        onChange={(e) => setEmail(e.target.value)}
      />

      <Checkbox
        labelClassName="!tw-mb-0"
        label="Change Password"
        checked={changePassword}
        onChange={(e) => setChangePassword(e.target.checked)}
      />

      {changePassword && (
        <TextInput
          label="Password"
          name="password"
          type="password"
          value={password}
          error={validate("password") === "error"}
          onChange={(e) => setPassword(e.target.value)}
        />
      )}

      <Dropdown
        options={roleDropdownOptions}
        value={roleDropdownOptions.find((o) => o.value === role)}
        label="Role"
        name="role"
        error={validate("role") === "error"}
        onChange={(o) => setRole(o.value)}
      />
    </FormWrapper>
  );
};

EditSuperUserForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  roleOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  formErrors: PropTypes.shape(),
  superUser: PropTypes.shape({
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
  }).isRequired,
};

EditSuperUserForm.defaultProps = {
  formErrors: null,
};

export default EditSuperUserForm;
